import type { FC } from "react";
import type { TimelineItemResponseDTO as TimelineItem } from "web_myplann/Infrastructure/Api/Api";
import { TimelineEntry } from "web_myplann/NotificationCenter/Components/TimelineEntry";
import { TimelineSection } from "web_myplann/NotificationCenter/Components/TimelineSection";
import { NOTIFICATION_CENTER_TABS } from "web_myplann/NotificationCenter/Constants/notificationCenterTabs";
import { TimelineDateStyle } from "web_myplann/NotificationCenter/Types/TimelineDateStyle";
import type { RecentGroup } from "web_myplann/NotificationCenter/Utils/groupTypes";

interface RecentGroupSectionProps {
	group: RecentGroup;
	onItemClick: (item: TimelineItem) => void;
}

export const RecentGroupSection: FC<RecentGroupSectionProps> = ({
	group,
	onItemClick,
}) => (
	<TimelineSection title={group.label} testId={`recent-group-${group.key}`}>
		{group.items.map((item, index) => (
			<TimelineEntry
				key={item.id}
				item={item}
				tab={NOTIFICATION_CENTER_TABS.Recent}
				onClick={onItemClick}
				isLast={index === group.items.length - 1}
				dateStyle={TimelineDateStyle.Relative}
			/>
		))}
	</TimelineSection>
);
